export function getLazyLoadByIndex(index: number, noLazyLoadCount = 2): boolean {
    return !(index <= noLazyLoadCount - 1);
}
